import api from '../baseApi.js'
import { byName, unwrap } from '../helpers.js'

export const studentsApi = {
  getAll: (params) =>
    api.get('/users', { params: { role: 'student', ...params } }).then(unwrap).then(byName),
  getOne: (id) => api.get(`/users/${id}`).then(unwrap),
  create: (data) => api.post('/users', { ...data, role: 'student' }).then(unwrap),
  update: (id, data) => api.put(`/users/${id}`, data).then(unwrap),
  remove: (id) => api.delete(`/users/${id}`).then(unwrap),
  updateAccountStatus: (id, accountStatus, reason) =>
    api.patch(`/users/${id}/account-status`, { accountStatus, ...(reason ? { reason } : {}) }).then(unwrap),
  bulkUpload: (formData) =>
    api.post('/users/bulk-upload', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    }).then(unwrap),
  bulkValidate: (formData) =>
    api.post('/users/bulk-validate', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    }).then(unwrap),
}

export const teachersApi = {
  getAll: (params) =>
    api.get('/users', { params: { role: 'teacher', ...params } }).then(unwrap).then(byName),
  getOne: (id) => api.get(`/users/${id}`).then(unwrap),
  create: (data) => api.post('/users', { ...data, role: 'teacher' }).then(unwrap),
  update: (id, data) => api.put(`/users/${id}`, data).then(unwrap),
  remove: (id) => api.delete(`/users/${id}`).then(unwrap),
  updateAccountStatus: (id, accountStatus, reason) =>
    api.patch(`/users/${id}/account-status`, { accountStatus, ...(reason ? { reason } : {}) }).then(unwrap),
}

export const parentsApi = {
  getAll: (params) =>
    api.get('/users', { params: { role: 'parent', ...params } }).then(unwrap).then(byName),
}

export const usersApi = {
  getAll: (params) =>
    api.get('/users', { params })
      .then(unwrap)
      .then((data) => (Array.isArray(data) ? data : data?.users ?? []))
      .then(byName),
  getOne: (id) => api.get(`/users/${id}`).then(unwrap),
  create: (data) => api.post('/users', data).then(unwrap),
  update: (id, data) => api.put(`/users/${id}`, data).then(unwrap),
  remove: (id) => api.delete(`/users/${id}`).then(unwrap),
  updateAccountStatus: (id, accountStatus, reason) =>
    api.patch(`/users/${id}/account-status`, { accountStatus, ...(reason ? { reason } : {}) }).then(unwrap),
}
